export enum VideoReviewStatus {
    NeedsReview,
    Reviewed,
    Coached
}
